import type { UserSummary } from "@dealer-center/ddc-pages-configuration-interface";
import { AddUserDialog } from "./AddUserDialog";

export interface AddUserModalProps {
  isOpen: boolean;
  accountId: string;
  onClose: () => void;
  onCreated: (user: UserSummary) => void;
}

/** Kept separate from the dialog so closing unmounts it, discarding the typed password. */
export const AddUserModal = ({
  isOpen,
  accountId,
  onClose,
  onCreated
}: AddUserModalProps) =>
  isOpen ? (
    <AddUserDialog
      accountId={accountId}
      onClose={onClose}
      onCreated={onCreated}
    />
  ) : null;
